module.exports = __webpack_public_path__ + "static/media/entregarinjualcaldesa.5c9cc56c.mp3";